export class SiteSetting {
  public id: number;
  public name: string;
  public description: string;

  constructor(data?: any) {
    this.id = data && data.id ? data.id : null;
    this.name = data && data.name ? data.name : '';
    this.description = data && data.description ? data.description : '';
  }
}



// WEBPACK FOOTER //
// /app/src/app/models/site-setting.ts